export default {
    page_title: "Kevi | Quotation Status",
    title: "Quotation Status",
    save_button: "Save",
    status_updated: "Statuses updated",
    status_options: {
        draft: "Draft",
        sent: "Sent",
        accepted: "Approved",
        rejected: "Rejected",
        expired: "Expired",
        cancelled: "Cancelled",
    },
};
